import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import FixtureInputModel from '../models/FixtureInputModel';
import FixtureInvoiceInputModel from '../models/FixtureInvoiceInputModel';

interface FixtureInvoiceInputState {
    input: FixtureInvoiceInputModel,
    showInvoiceInputPanel: boolean,
}

const initialState: FixtureInvoiceInputState = {
    input: {
        fixtureId: "",
        invoiceNo: "",
        issDate: "",//Date
        amount: 0,
        rcvDate: "",//Date
        forPeriodFrom: "",//Date 
        forPeriodTo: "",//Date 
        bankAccount: "",
        bankReceived: 0,
        privateCommSettled: 0,
        settledDate: "",//Date
    } as FixtureInvoiceInputModel,
    showInvoiceInputPanel: false,
}

export const FixtureInvoiceInputSlice = createSlice({
    name: "FixtureInvoiceInput",
    initialState,
    reducers: {
        setFixtureInputId: (state, action: PayloadAction<string>) => {
            state.input.fixtureId = action.payload;
        },
        setFixtureInvoiceInput: (state, action: PayloadAction<FixtureInvoiceInputModel>) => {
            state.input = action.payload;
        },
        setInvoiceNo: (state, action: PayloadAction<string>) => {
            state.input.invoiceNo = action.payload;
        },
        setIssDate: (state, action: PayloadAction<string>) => {
            state.input.issDate = action.payload;
        },
        setAmount: (state, action: PayloadAction<number>) => {
            state.input.amount = action.payload;
        },
        setRcvDate: (state, action: PayloadAction<string>) => {
            state.input.rcvDate = action.payload;
        },
        setForPeriodFrom: (state, action: PayloadAction<string>) => {
            state.input.forPeriodFrom = action.payload;
        },
        setForPeriodTo: (state, action: PayloadAction<string>) => {
            state.input.forPeriodTo = action.payload;
        },
        setBankAccount: (state, action: PayloadAction<string>) => {
            state.input.bankAccount = action.payload;
        },
        setBankReceived: (state, action: PayloadAction<number>) => {
            state.input.bankReceived = action.payload;
        },
        setPrivateCommSettled: (state, action: PayloadAction<number>) => {
            state.input.privateCommSettled = action.payload;
        },
        setSettledDate: (state, action: PayloadAction<string>) => {
            state.input.settledDate = action.payload;
        },
        setShowInvoiceInputPanel: (state, action: PayloadAction<boolean>) => {
            state.showInvoiceInputPanel = action.payload;
        },
    }
});

export const FixtureInvoiceInputSelector = createSelector(
    (state: RootState) => state.fixtureInvoiceInput,
    (data) => data
);

export const {
    setFixtureInputId,
    setInvoiceNo,
    setIssDate,
    setAmount,
    setRcvDate,
    setForPeriodFrom,
    setForPeriodTo,
    setBankAccount,
    setBankReceived,
    setPrivateCommSettled,
    setSettledDate,
    setShowInvoiceInputPanel,
    setFixtureInvoiceInput
} = FixtureInvoiceInputSlice.actions;

export default FixtureInvoiceInputSlice.reducer;